import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { DataQualityGrade } from '@lune-climate/lune'
import { Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'

import { DataQualityScoreCircle, getDataQualityScoreLabel } from './DataQualityScoreCircle'

export const DataQualityScoreWithLabel = ({
    score,
    size,
    extraLabel,
    empty,
}: {
    score: DataQualityGrade
    size?: 'md' | 'lg'
    extraLabel?: string
    empty?: boolean
}) => {
    useLingui()

    return (
        <Box
            sx={{
                display: 'flex',
                gap: 3,
                alignItems: 'center',
                width: '100%',
            }}
        >
            <DataQualityScoreCircle score={score} size={size} empty={empty} />
            <Box sx={{ width: 'max-content' }}>
                <Text
                    variant={size === 'lg' ? 'h5' : size === 'md' ? 'body2' : 'h6'}
                    sx={{ fontWeight: '700' }}
                >
                    {empty ? t`No data` : getDataQualityScoreLabel(score)}
                </Text>
                {extraLabel && (
                    <Text
                        variant={size === 'lg' ? 'body2' : 'body3'}
                        sx={{ color: `Grey600`, mt: 1, width: '100%' }}
                    >
                        {extraLabel}
                    </Text>
                )}
            </Box>
        </Box>
    )
}

export default DataQualityScoreWithLabel
